/**
 * c-featured-collections
 * gallery-list には prev/next の disabled 制御が無いので、スクロール位置から自前で切り替える。
 * disabled になったら CSS で visibility: hidden にして非表示。
 */
(function () {
  if (window.__cFeaturedCollectionsInit) return;
  window.__cFeaturedCollectionsInit = true;

  function setupGallery(gallery) {
    if (gallery.dataset.cFcInitialized === '1') return;
    gallery.dataset.cFcInitialized = '1';

    const scrollable = gallery.querySelector('scrollable-content');
    const prevNext = gallery.querySelector('prev-next-buttons');
    if (!scrollable || !prevNext) return;

    const prevBtn = prevNext.querySelector('button:first-of-type');
    const nextBtn = prevNext.querySelector('button:last-of-type');
    if (!prevBtn || !nextBtn) return;

    const progressBar = gallery.querySelector('.c-featured-collections__progress-wrapper .progress-bar');

    const update = () => {
      const viewport = scrollable.clientWidth || 1;
      const max = scrollable.scrollWidth - viewport;
      const left = Math.abs(scrollable.scrollLeft);
      const noScroll = max <= 1;
      // スクロール不要（4枚以下）なら両方非表示。それ以外は先頭/末尾で出し分け
      prevBtn.disabled = noScroll || left <= 1;
      nextBtn.disabled = noScroll || left >= max - 1;

      if (progressBar) {
        const divider = noScroll ? 1 : scrollable.scrollWidth / viewport;
        const progress = noScroll ? 0 : Math.min(left / max, 1) * 100;
        progressBar.style.setProperty('--divider', divider.toString());
        progressBar.style.setProperty('--transform', `${progress}%`);
      }
    };

    scrollable.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    // 初期判定（layout 後に走らせる）
    requestAnimationFrame(update);
  }

  function init() {
    document.querySelectorAll('.c-featured-collections__gallery').forEach(setupGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme Editor で section 追加されたときも初期化
  document.addEventListener('shopify:section:load', init);
})();
